export default "__VITE_ASSET__BL2zPA6t__"